import { SelectOption } from '../inputs/SelectInput';

export interface IExtractValueOptionListQuery {
  withDisabled?: boolean;
}

/**
 * Ritorna la lista di tutti i possibili valori selezionabili da una
 * lista di opzioni. Di default le disabilitate sono _escluse_
 *
 * @param withDisabled Se `true`, include anche le opzioni disabilitate
 */
export function extractValueOptionList(
  options: SelectOption[] | null | undefined,
  query: IExtractValueOptionListQuery = {},
) {
  const { withDisabled } = query;

  const optionListValues: Array<string | number | undefined> = [];
  options?.forEach(o => {
    if (o.options && o.options.length > 0) {
      optionListValues.push(
        ...o.options
          .filter(o => Boolean(o.value) && (!o.disabled || withDisabled))
          .map(o => o.value),
      );
    }
    if (o.value && (!o.disabled || withDisabled)) {
      optionListValues.push(o.value);
    }
  });

  return optionListValues;
}
